import { render, staticRenderFns } from "./MeasurementNode.vue?vue&type=template&id=ae2483ba&scoped=true&lang=pug"
import script from "./MeasurementNode.vue?vue&type=script&lang=js"
export * from "./MeasurementNode.vue?vue&type=script&lang=js"
import style0 from "./MeasurementNode.vue?vue&type=style&index=0&id=ae2483ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae2483ba",
  null
  
)

export default component.exports